import {Col} from "react-bootstrap";
import React from "react";

export const SurveyNavigationSeparator = (props) => {
    return <Col xs={12} className="sb-survey-form-navigation-boundary">
        <hr/>
    </Col>;
};
